import React, { useEffect, useState } from "react";
import { Avatar, Row, Col, Card, Tabs, Typography } from "antd";
import axios from "axios";
import { avatar01 } from "../../../commons/PanelImagepath";
import { isAuthenticated } from "../../../commons/Auth/auth";
import UpdateProfile from "./UpdateProfile";
import UpdatePassword from "./UpdatePassword";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import { Error } from "../../../commons/Messages/Messages";
import { useTranslation } from "react-i18next";
import { UserOutlined } from "@ant-design/icons";
import "./ProfilePage.css";
import DeleteAccount from "../../../commons/Auth/DeleteAccount";
import PortalConsent from "../portal/PortalConsent";

const { Title, Text } = Typography;

const Profile = () => {
  const { t } = useTranslation("dashboard");
  const [user, setUser] = useState({});

  const getUser = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/users/user/${isAuthenticated()?.serviceProviderId}`,
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        }
      );
      if (res.status === 200 || res.status === 304) {
        setUser(res.data);
      } else {
        Error(res.data.errorMessage);
      }
    } catch (err) {
      generalErrorAlert(err);
    }
  };

  useEffect(() => {
    getUser();
  }, []);

  const details = [
    { label: t("Name"), value: `${user?.firstName || ""} ${user?.lastName || ""}`.trim() },
    { label: t("Date of Birth"), value: user?.dob },
    { label: t("Email"), value: user?.email },
    { label: t("Phone"), value: user?.phone },
    {
      label: t("Address"),
      value: `${user?.city || ""}, ${user?.state || ""} - ${user?.zipCode || ""}, ${user?.country || ""}`
    }
  ];

  const tabs = [
    {
      key: "1",
      label: t("About"),
      children: (
        <Card title={t("Profile")} extra={<UpdateProfile data={user} updateParent={getUser} />}>
          <Row gutter={[16, 12]}>
            {details.map(item => (
              <React.Fragment key={item.label}>
                <Col xs={24} sm={8}>
                  <Text type="secondary">{item.label}:</Text>
                </Col>
                <Col xs={24} sm={16} className="profile-page__value">
                  {item.value}
                </Col>
              </React.Fragment>
            ))}
          </Row>
        </Card>
      )
    },
    // { key: "2", label: t("Bank Details"), children: <UpdateBankDetails data={user?.bankDetails} updateParent={getUser} /> },
    { key: "notifications", label: t("Notifications"), children: <PortalConsent /> },
    { key: "3", label: t("Password"), children: (
        <>
          <UpdatePassword />
          <DeleteAccount />
        </>
      )
    }
  ];

  return (
    <div className="profile-page">
      <Card className="profile-page__header">
        <div className="profile-page__identity">
          <Avatar
            size={{ xs: 64, sm: 80, md: 100, lg: 100, xl: 100, xxl: 100 }}
            icon={<UserOutlined />}
            src={user?.picture?.url ? user?.picture?.url : avatar01}
          />
          <div className="profile-page__who">
            <Title level={4}>
              {user?.firstName} {user?.lastName}
            </Title>
            <Text type="secondary">{user?.email}</Text>
            {user?.description && <p>{user?.description}</p>}
          </div>
        </div>
      </Card>
      <Tabs defaultActiveKey="1" items={tabs} />
    </div>
  );
};

export default Profile;
